function ColorExamplePage(): JSX.Element {
  return (
    <section id="colors" className="ExamplesPage__Section">
      <h1 className="ExamplesPage__SectionTitle">Colors</h1>
      <div className="ColorChart">
        <div className="ColorCol">
          <div className="ColorName">Gray</div>
          <div className="ColorRow dark dsd-gray-100">
            <div>100</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-200">
            <div>200</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-300">
            <div>300</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-400">
            <div>400</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-500">
            <div>500</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-600">
            <div>600</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-700">
            <div>700</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-gray-800">
            <div>800</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark slate-900">
            <div>900</div>
            <div>#XXXXXX</div>
          </div>
        </div>
        <div className="ColorCol">
          <div className="ColorName">Blue</div>
          <div className="ColorRow light dsd-blue-100">
            <div>100</div>
            <div>#XXXXX</div>
          </div>
          <div className="ColorRow light dsd-blue-200">
            <div>200</div>
            <div>#XXXXX</div>
          </div>
          <div className="ColorRow dark dsd-blue-300">
            <div>300</div>
            <div>#XXXXX</div>
          </div>
          <div className="ColorRow dark dsd-blue-400">
            <div>400</div>
            <div>#XXXXX</div>
          </div>
          <div className="ColorRow dark dsd-blue-500">
            <div>500</div>
            <div>#XXXXX</div>
          </div>
        </div>
        <div className="ColorCol">
          <div className="ColorName">Red</div>
          <div className="ColorRow light dsd-red-100">
            <div>100</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-red-500">
            <div>500</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorName">Yellow</div>
          <div className="ColorRow light dsd-yellow-100">
            <div>100</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-yellow-500">
            <div>500</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorName">Green</div>
          <div className="ColorRow light dsd-green-100">
            <div>100</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-green-500">
            <div>500</div>
            <div>#XXXXXX</div>
          </div>
        </div>
        <div className="ColorCol">
          <div className="ColorName">Other</div>
          <div className="ColorRow light color-white">
            <div>white</div>
            <div>#FFFFFF</div>
          </div>
          <div className="ColorRow dark color-black">
            <div>black</div>
            <div>#000000</div>
          </div>
          <div className="ColorName">Data Visualization</div>
          <div className="ColorRow dark dsd-data-300">
            <div>dsd-data-300</div>
            <div>#XXXXXX</div>
          </div>
          <div className="ColorRow dark dsd-data-400">
            <div>dsd-data-400</div>
            <div>#XXXXXX</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ColorExamplePage;
